export const PAYMENT_STATUS_RESET_STATE = 'PAYMENT_STATUS_RESET_STATE';
export const PAYMENT_STATUS_CURRENT_ITEM = 'PAYMENT_STATUS_CURRENT_ITEM';

export const PAYMENT_STATUS_REQUEST_LOADING = 'PAYMENT_STATUS_REQUEST_LOADING';
export const PAYMENT_STATUS_REQUEST_SUCCESS = 'PAYMENT_STATUS_REQUEST_SUCCESS';
export const PAYMENT_STATUS_REQUEST_FAILED = 'PAYMENT_STATUS_REQUEST_FAILED';

export const PAYMENT_STATUS_CURRENT_ACTION = 'PAYMENT_STATUS_CURRENT_ACTION';
export const PAYMENT_STATUS_RESET_ACTION = 'PAYMENT_STATUS_RESET_ACTION';